<div class="selector-container">
  <div class="flex-container" #container>
      <div *ngFor="let entry of dataEntries" class="flex-item-big">
        <app-selector [id]="entry.ID" [name]="entry.name | translate" [description]="entry.description | translate" [image]="entry.image"  [tooltip]="entry.tooltip" [checked]="entry.checked" (selected)="onSelectorClicked($event)"></app-selector>
      </div>
  </div>
  <app-custom-scrollbar [containerScrollRef]="container"></app-custom-scrollbar>
</div>